export default "__VITE_ASSET__uj07YLxS__"